type ImageGalleryPositionParams = {
    idList: number[];
    currentImageId: number;
    canGoLeft: boolean;
    canGoRight: boolean;
};

type ImageGalleryPosition = {
    showNavigationArrows: boolean;
    imageCounterLabel: string;
    previousImageId: number | null;
    nextImageId: number | null;
};

export function getImageGalleryPosition({
    idList,
    currentImageId,
    canGoLeft,
    canGoRight
}: ImageGalleryPositionParams): ImageGalleryPosition {
    const currentIndex = idList.indexOf(currentImageId);

    return {
        showNavigationArrows: idList.length > 1,
        imageCounterLabel: idList.length > 0 ? `(${currentIndex + 1} / ${idList.length})` : '',
        previousImageId: canGoLeft ? idList[currentIndex - 1] : null,
        nextImageId: canGoRight ? idList[currentIndex + 1] : null
    };
}
